import styled from "styled-components";

export const Container = styled.section`
  height: 50vh;
  width: 100%;
`;
